export default class AlertManager {
  constructor(apiUrl, el, storageKey) {
    this.apiUrl = apiUrl;
    this.el = el;
    this.storageKey = storageKey;
    this.alert = null;
  }

  // Function to fetch alerts from the API
  async fetchAlerts() {
    try {
      const response = await fetch(this.apiUrl);
      const alerts = await response.json();
      return alerts;
    } catch (error) {
      console.error('Error fetching alerts:', error);
      return [];
    }
  }

  // Function to check if an alert is already dismissed
  isAlertDismissed(alertId) {
    const dismissedAlerts = JSON.parse(localStorage.getItem(this.storageKey)) || [];
    return dismissedAlerts.includes(alertId);
  }

  // Function to display an alert
  displayAlert() {
    console.log(this.alert);
  }

  // Main function to process alerts
  async processAlerts() {
    const alerts = await this.fetchAlerts();

    if (!Array.isArray(alerts) || alerts.length === 0) {
      console.warn("No alerts found.");
      return;
    }

    const currentPath = window.location.pathname;

    let priorityAlert = alerts.find((alert) => {
      return (
        !this.isAlertDismissed(alert.id) && alert.visibility === currentPath
      );
    });

    if (!priorityAlert) {
      priorityAlert = alerts.find((alert) => {
        return !this.isAlertDismissed(alert.id) && alert.visibility === "";
      });
    }

    if (priorityAlert && !this.isAlertDismissed(priorityAlert.id)) {
      this.alert = priorityAlert;
    }
  }


  // Event listener for closing alert
  handleAlertClose(alertId) {
    const dismissedAlerts = JSON.parse(localStorage.getItem(this.storageKey)) || [];
    dismissedAlerts.push(alertId);
    localStorage.setItem(this.storageKey, JSON.stringify(dismissedAlerts));
  }

  // Initialize alert processing on page load
  async initialize() {
    return this.processAlerts();
  }
}